<h1 class="text-3xl">
  <ng-content select="[title]" />
</h1>

<p class="text-lg font-light text-gray-500">
  <ng-content select="[subtitle]" />
</p>
